import {isJwtExpired} from "jwt-check-expiration";

export const checkToken = (token) => {
    try {
        return isJwtExpired(token);
    } catch (error) {
        return true;
    }
}